import $ from 'jquery';
import M from 'materialize-css/dist/js/materialize';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as actionsPhysicalConfirmation from '../../../actions/physicalConfirmationAction';
import BackButton from '../../../components/UI/BackButton';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { isNullOrEmpty, openCloseScanner, showMessageToast, translate } from '../../../utils/util';
import ConfirmationReceipt from '../Confirmation/ConfirmationReceipt';
import FinalizeConfirmation from '../Confirmation/FinalizeConfirmation';
import PrintConfirmationList from '../Print/PrintConfirmationList';
import SmallPartsSearch from '../SmallParts/SmallPartsSearch';
import ReceiptList from './ReceiptList';
import ReceiptSearch from './ReceiptSearch';
import ScannerReceiptItem from './ScannerReceiptItem';

const Receipt = (props) => {
    const [table, setTable] = useState(0);
    const [receipts, setReceipt] = useState([]);

    useEffect(() => {
        if (isNullOrEmpty(props.user?.resource)) {
            showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
            leave()
        }

        let receiptFilter = [];
        Object.assign(receiptFilter, props.receipts);
        if (receiptFilter && receiptFilter.length > 0) {
            receiptFilter = receiptFilter.filter((f) => !f.checked);
        }
        setReceipt(receiptFilter);
        // eslint-disable-next-line
    }, [props.receipts, props.selectedTab]);

    useEffect(() => {
        const el = $('.tabs');
        M.Tabs.init(el);
        M.Tabs.getInstance(el).select(getTabName(props.selectedTab));

        return () => {
            openCloseScanner('close');
        };
        // eslint-disable-next-line
    }, []);

    const getTabName = (tabIndex) => {
        switch (tabIndex) {
            case 0:
                return 'searchReceipts';
            case 1:
                return 'scannerItem';
            case 2:
                return 'searchSmallParts';
            case 3:
                return 'confirmationsReceipts';
            case 4:
                return 'finalizeConfirmation';
            case 5:
                return 'printerReceipts'
            default:
                return 'searchReceipts';
        }
    }

    const onSeletedItemChange = (goback) => {
        props.history.push({
            pathname: `./confirmation`,
            state: { goBack: goback, truckKanban: props.filter.truckKanban },
            ...props
        });
    }

    const onConfirmationReceiptFinished = () => {
        const el = $('.tabs');
        const dados = M.Tabs.getInstance(el);
        dados.select('searchReceipts');
        const txtMvm = document.getElementById('txtMvm');

        if (txtMvm) {
            txtMvm.value = '';
            txtMvm.focus();
        }
    };

    const onSelectedTab = () => {
        const el = $('.tabs');
        let index = M.Tabs.getInstance(el).index;
        if (table !== index) {
            setTable(index);
        }
        if (index > 0) {
            props.setActiveTab(index);
        }
    };

    const leave = () => {
        if (props.filter.truckKanban || props.location?.state?.truckKanban || props.location?.location?.state?.truckKanban) {
            return props.history.replace({ pathname: '/truckkanban/parameters' })
        }

        if (props.location?.state?.filterContainer) {
            return props.history.replace({ pathname: '/container/spawing/container' })
        }

        return props.history.replace({
            pathname: `./home`,
        });
    }

    return (
        <div className="">
            <BackButton {...props} onClick={() => leave()} />
            <div className="third-text-color">
                <div className="row" style={{ marginBottom: '-1px', marginTop: '10px' }}>
                    <ul className="tabs">
                        <li className="tab col s2">
                            <a className="active" href="#searchReceipts" onClick={onSelectedTab}>
                                <i className="material-icons prefix">list</i>
                            </a>
                        </li>
                        <li className={`tab col s2 ${props.receipts && props.receipts.length > 0 ? '' : 'disabled'}`}>
                            <a className="" href="#scannerItem" onClick={onSelectedTab}>
                                <i className="material-icons prefix">camera_alt</i>
                            </a>
                        </li>
                        < li className={`tab col s2 ${props.receipts && props.receipts.length > 0 ? '' : 'disabled'}`} >
                            <a className="" href="#searchSmallParts" onClick={onSelectedTab}>
                                <i className="material-icons prefix">view_module</i>
                            </a>
                        </li>
                        <li className="tab col s2">
                            <a className="" href="#confirmationsReceipts" onClick={onSelectedTab}>
                                <i className="material-icons prefix">playlist_add</i>
                            </a>
                        </li>
                        {
                            !props.filter.truckKanban &&
                            <li className="tab col s2">
                                <a className="" href="#finalizeConfirmation" onClick={onSelectedTab}>
                                    <i className="material-icons prefix">playlist_add_check</i>
                                </a>
                            </li>
                        }
                        <li className="tab col s2">
                            <a className="" href="#printerReceipts" onClick={onSelectedTab}>
                                <i className="material-icons prefix">printer</i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="searchReceipts" className="">
                <ReceiptSearch
                    {...props}
                    mvmFilter={props.location?.state?.mvmNumber}
                    journeyFilter={props.location?.state?.journey} />
                {
                    props.physicalConfirmation?.unload && props.physicalConfirmation?.unload?.message !== "" && (
                        <div className="container" style={{ paddingBlockEnd: "10px", color: (props.physicalConfirmation.unload.startUnload ? "green" : "orange") }} >
                            <i className="mdi mdi mdi-24px mdi-arrow-collapse-down" style={{ color: (props.physicalConfirmation.unload.startUnload ? "green" : "orange") }} />
                            {translate('start-unload', 'physical-confirmation')} : {props.physicalConfirmation.unload.startUnload ? "Realizada!" : props.physicalConfirmation.unload.message}
                        </div>
                    )
                }
                <ReceiptList {...props} receipts={receipts} filterAlmox={true} onSelectedItemChange={onSeletedItemChange} />
            </div>
            {/* ---------------- Digitar ou Scanear item -------------- */}
            <div id="scannerItem" className="">
                {
                    props.receipts && props.receipts.length && table === 1 &&
                    <ScannerReceiptItem {...props} onSelectedItemChange={onSeletedItemChange} onReadItemChange={onSeletedItemChange} />
                }
            </div>
            <div id="searchSmallParts" className="">
                {
                    table === 2 && props.receipts && props.receipts.length && (
                        <SmallPartsSearch {...props} onSelectedItemChange={onSeletedItemChange} />
                    )
                }
            </div>
            {/* ---------------- Lista de Confirmações -------------- */}
            <div id="confirmationsReceipts" className="col s12">
                {
                    table === 3 && <ConfirmationReceipt{...props} onFinishConfirmations={onConfirmationReceiptFinished} />
                }
            </div>
            {
                !props.filter.truckKanban &&
                <div id="finalizeConfirmation" className="col s12">
                    {
                        table === 4 && <FinalizeConfirmation{...props} onFinishConfirmations={onConfirmationReceiptFinished} />
                    }
                </div>
            }
            <div id="printerReceipts" className="col s12">
                {
                    table === (props.filter.truckKanban ? 4 : 5) && <PrintConfirmationList{...props} onSelectedItemChange={onSeletedItemChange} />
                }
            </div>
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        selectedTab: state.physicalConfirmationReducer.selectedTab,
        receipts: state.physicalConfirmationReducer.receipts,
        config: state.configReducer.config,
        confirmations: state.physicalConfirmationReducer.transmissions,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        filter: state.physicalConfirmationReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetPhisicalConfirmation: () => {
            dispatch(PhysicalConfirmationService.clearConfirmations());
            dispatch(PhysicalConfirmationService.clearReceipts());
        },
        setActiveTab: (tabIndex) => {
            dispatch(PhysicalConfirmationService.setActiveTab(tabIndex));
        },
        setFilter: (filter) => {
            dispatch(actionsPhysicalConfirmation.setFilter(filter));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Receipt));